import { Component } from '@angular/core';

@Component({
  selector: 'app-managementdashboard',
  templateUrl: './managementdashboard.component.html',
  styleUrls: ['./managementdashboard.component.css']
})
export class ManagementdashboardComponent {

}
